<script lang="ts">
  import { _ } from "svelte-i18n";
  export let difficulty: number;
  export let compact: boolean = false;
  export let style="";
  function piecewise(v) {
    let xs =  [40, 45,  50,  62,  75,  90,  110, 130, 150];
    let ys =   [1.0, 1.5, 2.0, 2.5, 3.0,  3.5, 4.0, 4.5, 5.0];
    if (v <= 40) return 20;

    let y = 100;
    xs.every((x, i) => {
      if (x > v) {
        let t = (v-xs[i-1])/(x-xs[i-1]);
        y = (ys[i-1] + t*(ys[i]-ys[i-1])-0.25)*20;
        return false;
      }
      return true;
    });
    return Math.min(100, Math.max(20, y));
  }
  function getDiamonds(difficulty) {

    // NOTE: These are fontawesome symbols for dimand and diamond-half-stroke.
    // Need at least fontawesome 6.2.1
    if (difficulty <= 45) return "";
    else if (difficulty <= 50) return "";
    else if (difficulty <= 62) return "";
    else if (difficulty <= 75) return "";
    else if (difficulty <= 90) return "";
    else if (difficulty <= 110) return "";
    else if (difficulty <= 130) return "";
    else if (difficulty <= 150) return "";
    else return "";
  }
</script>

{#if !compact}
    <span style="{style} --percent: {piecewise(difficulty)}%"/>
{:else}
    <div class="w-max fa-solid text-[10px]">{getDiamonds(difficulty)}</div>
{/if}

<style lang="scss">
  span {
    white-space: nowrap;
    --star-color: black;
    --star-background: lightgray;

    &::before {
      content: '◆ ◆ ◆ ◆ ◆';
      background: linear-gradient(90deg, var(--star-color) var(--percent), var(--star-background) var(--percent));

      background-clip: text;
      -webkit-background-clip: text;

      -webkit-text-fill-color: transparent;
    }
  }
</style>